import React from "react";
import { connect } from "react-redux";
import { setMsaCfa, setMsaMdsCost, setMsaTerm } from "../redux/actions";
import {
  isCfaRentOrLease,
  isMsaDefaultCfaConfiguredForRentOrLease,
  isMsaDefaultTermConfiguredForRentOrLease,
  hasSelectionsUnderWarranty
} from "../redux/selectors";
import style from "./MsaOptions.module.css";
import { OnBlurInput } from "./OnBlurInput";
import { Form, Table } from "react-bootstrap";
import MsaClickCharges from "./MsaClickCharges";

function MsaOptions({
  isCfaRentOrLease,
  msaTerm,
  msaDefaultTerm,
  msaCfa,
  msaDefaultCfa,
  msaMdsCost,
  msaDefaultMdsCost,
  msaPriceFlag,
  msaPayableMethod,
  msaInstalmentFrequency,
  isMsaDefaultTermConfiguredForRentOrLease,
  isMsaDefaultCfaConfiguredForRentOrLease,
  setMsaTerm,
  setMsaCfa,
  setMsaMdsCost,
  hasSelectionsUnderWarranty,
  hasCharges
}) {
  return (
    <>
      { !hasSelectionsUnderWarranty && hasCharges ? (
      <div className="form-group">
        <Form.Label>Click Charges</Form.Label>

        <MsaClickCharges />
      </div>
      ) : null}

      <div className="form-group">
        <Form.Label>Cost</Form.Label>

        <Table className={style.table} variant="sm">
          <thead>
            <tr>
              <th className={style.colHead} />
              <th className={style.colMinPrice}>Default</th>
              <th className={style.colTargetPrice}>Target</th>
            </tr>
          </thead>
          <tbody>
            {isCfaRentOrLease ? (
              <>
                <tr>
                  <th>Term</th>
                  <td>{msaDefaultTerm}</td>
                  <td>
                    <OnBlurInput
                      type="number"
                      className="form-control"
                      value={msaTerm}
                      disabled={!isMsaDefaultTermConfiguredForRentOrLease}
                      onConfirm={e => setMsaTerm(e.target.value)}
                      min={msaDefaultTerm}
                      max={60}
                      required
                    />
                  </td>
                </tr>

                <tr>
                  <th>CF per thousand</th>
                  <td>{msaDefaultCfa}</td>
                  <td>
                    <OnBlurInput
                      type="number"
                      className="form-control"
                      value={msaCfa}
                      disabled={
                        msaTerm === msaDefaultTerm ||
                        !isMsaDefaultCfaConfiguredForRentOrLease
                      }
                      onConfirm={e => setMsaCfa(e.target.value)}
                      min={msaDefaultCfa}
                      max={1000}
                      required
                    />
                  </td>
                </tr>

                <tr>
                  <th colSpan={2}>Payable Method</th>
                  <td>{msaPayableMethod}</td>
                </tr>
                <tr>
                  <th colSpan={2}>Instalment Frequency</th>
                  <td>{msaInstalmentFrequency}</td>
                </tr>
              </>
            ) : null}

            {msaDefaultMdsCost > 0 ? (
              <tr>
                <th>MDS Cost</th>
                <td>{msaDefaultMdsCost}</td>
                <td>
                  <OnBlurInput
                    type="number"
                    className="form-control"
                    value={msaMdsCost}
                    onConfirm={e => setMsaMdsCost(e.target.value)}
                    min={1}
                    max={100000}
                  />
                </td>
              </tr>
            ) : null}

            <tr>
              <th colSpan={2}>Price Flag</th>
              <td>{msaPriceFlag}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </>
  );
}

export default connect(
  state => {
    const { product } = state;

    return {
      isCfaRentOrLease: isCfaRentOrLease(state),
      msaTerm: product.msaTerm,
      msaDefaultTerm: product.msaDefaultTerm,
      msaCfa: product.msaCfa,
      msaDefaultCfa: product.msaDefaultCfa,
      msaMdsCost: product.msaMdsCost,
      msaDefaultMdsCost: product.msaDefaultMdsCost,
      msaPriceFlag: product.msaPriceFlag,
      msaPayableMethod: product.msaPayableMethod,
      msaInstalmentFrequency: product.msaInstalmentFrequency,
      isMsaDefaultTermConfiguredForRentOrLease: isMsaDefaultTermConfiguredForRentOrLease(
        state
      ),
      isMsaDefaultCfaConfiguredForRentOrLease: isMsaDefaultCfaConfiguredForRentOrLease(
        state
      ),
      hasSelectionsUnderWarranty: hasSelectionsUnderWarranty(state)
    };
  },
  { setMsaTerm, setMsaCfa, setMsaMdsCost }
)(MsaOptions);
